export const getBaseConfig = (config) => {
  return {
    translations: config.translations ?? {},
    translationsPath: config.translationsPath,
    reducers: config.reducers ?? {},
    claimTypes: {
      //optional
      tenant:
        config.claimTypes?.tenant ??
        "https://skillsfoundry.ey.com/claims/tenant",
      securityHash:
        config.claimTypes?.securityHash ??
        "https://skillsfoundry.ey.com/claims/securityhash",
      commonPermissions:
        config.claimTypes?.commonPermissions ??
        "https://skillsfoundry.ey.com/claims/permissions/common",
      tenantPermissions:
        config.claimTypes?.tenantPermissions ??
        "https://skillsfoundry.ey.com/claims/permissions/tenant",
      adminPermissions:
        config.claimTypes?.adminPermissions ??
        "https://skillsfoundry.ey.com/claims/permissions/admin",
    },
    apiEndpoints: {
      base: config.apiEndpoints?.base ?? "https://localhost:5001", //variable
      identityLogout:
        config.apiEndpoints?.identityLogout ?? "core/identity/logout",
      identityCurrent:
        config.apiEndpoints?.identityCurrent ?? "core/identity/token",
      identityConfig:
        config.apiEndpoints?.identityConfig ?? "core/identity/config",
      identityTenants:
        config.apiEndpoints?.identityTenants ?? "core/identity/tenants",
      identityAvatar:
        config.apiEndpoints?.identityAvatar ?? "core/identity/avatar",
      identityTenantToken:
        config.apiEndpoints?.identityTenantToken ?? "baseline/identity/token",
      nonceToken: config.apiEndpoints?.nonceToken ?? "core/nonce/token",
      maintenance:
        config.apiEndpoints?.maintenance ?? "core/content/maintenance",
      tenantConfig:
        config.apiEndpoints?.tenantConfig ?? "baseline/tenant-configs",
    },
    auth0Config: {
      clientId: config.auth0Config?.auth?.clientId,
      domain: config.auth0Config?.auth?.domain,
      audience: config.auth0Config?.auth?.audience,
      scope: config.auth0Config?.auth?.scope,
    },
    graphConfig: {
      graphEndpoint:
        config.graphConfig?.graphEndpoint ?? "https://graph.microsoft.com/v1.0",
      userPhotosApi: config.graphConfig?.userPhotosApi ?? "/me/photo/$value",
      userPhotoByIdOrPrincipalName:
        config.graphConfig?.userPhotoByIdOrPrincipalName ??
        "/users/{user}/photo/$value",
      usersApi: config.graphConfig?.usersApi ?? "/users",
      scope: config.graphConfig?.scope ?? "User.Read", //minimum permission to retrieve login token with all required scopes
    },
    forceTenant: config.forceTenant,
    themeProvider: config.themeProvider,
    appInsights: {
      enable: config.appInsights?.enable,
      instrumentationKey: config.appInsights?.instrumentationKey,
    },
    //key used for the storage in redux store
    persistStoreKey: config.persistStoreKey ?? "root",
    appName: config.appName,
    authInstance: config.authInstance ?? "Default",
  };
};
